import React from 'react';
import PropTypes from 'prop-types';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {graphql} from 'react-apollo';

import {loadDealLead as load, query} from 'flows/deal/leadmanage';
import {sendAnnouncement as announce} from 'flows/deal/announce/index';

import Spinner from 'components/Spinner';
import Page from 'components/Page';
import InvitedInvestors from 'flows/deal/investors/invited';
import AllocateInvestors from 'flows/deal/investors/allocate';
import FinalizedInvestors from 'flows/deal/investors/finalized';
import LeadDealStatus from 'flows/deal/status_transitions';

import LeadDealSummary from './components/LeadDealSummary';
import SendAnnouncement from '../announce';
import SendInvite from '../invite';

import './style.css';

export class DealLeadContainer extends React.Component {
  constructor() {
    super();
    this.announce = this.announce.bind(this);
  }
  componentDidMount() {
    const deal = {id: this.props.params.dealId};
    this.props.load({deal});
  }
  announce() {
    this.props.announce({
      deal: this.props.data.deal,
    });
  }
  renderInvestors() {
    const {deal} = this.props.data || {};
    if (deal.status === 'allocating') {
      return (<InvitedInvestors deal={deal} />);
    } else if (deal.status === 'finalizing') {
      return (<AllocateInvestors deal={deal} />);
    } else if (deal.status === 'finalized' || deal.status === 'closed') {
      return (<FinalizedInvestors deal={deal} />);
    }
    return 'Not Implemented';
  }
  render() {
    const {deal, loading} = this.props.data || {};
    if (loading || !deal) {
      return (
        <Spinner />
      );
    }

    return (
      <section className="fullPageContainer">
        <h1 data-test="deal_header">{deal.name}</h1>
        <section styleName="container">
          <aside styleName="left">
            <LeadDealSummary announce={this.announce} deal={deal} />
            <LeadDealStatus deal={deal} />
          </aside>
          <section
            styleName="right"
            className="content"
          >
            <Page>
              {this.renderInvestors()}
            </Page>
          </section>
        </section>
        <SendAnnouncement deal={deal} />
        <SendInvite deal={deal} />
      </section>
    );

  }
}

DealLeadContainer.propTypes = {
  load: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  announce: PropTypes.func.isRequired,
};

const mapPropsToOptions = ({params: {dealId}}) => ({variables: {dealId}});

export default compose(
  graphql(query, {
    options: mapPropsToOptions,
  }),
  connect(null, {load, announce}),
)(DealLeadContainer);



// WEBPACK FOOTER //
// ./web/flows/deal/lead/index.js